import { create } from 'zustand';
import { clearChatSessions } from '@/features/chat-send/chatSessionCache';

interface SessionState {
  familyId: string | null;
  activeMemberId: string | null;
  isAdmin: boolean;
  isHydrated: boolean;
  login: (familyId: string) => void;
  setLoginIdentifier: (loginIdentifier: string) => void;
  loginAdmin: () => void;
  setActiveMemberId: (memberId: string | null) => void;
  logout: (scope?: 'family' | 'admin') => void;
  setHydrated: () => void;
}

/**
 * Токенов здесь нет: сессия — httpOnly cookie на бэкенде. familyId держим только
 * для показа в шапке, восстанавливаем запросом `/auth/session` при загрузке.
 */
export const useSessionStore = create<SessionState>((set) => ({
  familyId: null,
  activeMemberId: null,
  isAdmin: false,
  isHydrated: false,
  login: (familyId) => set((state) => {
    if (state.familyId && state.familyId !== familyId) clearChatSessions();
    return { familyId, activeMemberId: state.familyId === familyId ? state.activeMemberId : null };
  }),
  loginAdmin: () => set({ isAdmin: true }),
  setLoginIdentifier: (familyId) => set({ familyId }),
  setActiveMemberId: (activeMemberId) => set({ activeMemberId }),
  logout: (scope = 'family') => {
    if (scope === 'family') clearChatSessions();
    set(scope === 'admin' ? { isAdmin: false } : { familyId: null, activeMemberId: null });
  },
  setHydrated: () => set({ isHydrated: true }),
}));
